import React from 'react';
import { Helmet } from 'react-helmet-async';

// Production domain - all hreflang URLs should point here
const PRODUCTION_DOMAIN = 'https://thegdevelopments.co';

/**
 * Hreflang Component for SEO language annotations
 * Adds proper hreflang tags to page <head>
 * Uses production domain to avoid exposing preview/internal URLs
 * 
 * @param {string} enPath - English page path (e.g., "/projects")
 * @param {string} arPath - Arabic page path (e.g., "/ar/projects")
 * @param {string} currentLang - Current page language ("en" or "ar")
 */
const Hreflang = ({ enPath, arPath, currentLang }) => {
  // Always use production domain for hreflang URLs
  const enUrl = `${PRODUCTION_DOMAIN}${enPath}`;
  const arUrl = `${PRODUCTION_DOMAIN}${arPath}`;
  
  return (
    <Helmet>
      {/* English version */}
      <link rel="alternate" hrefLang="en" href={enUrl} />
      {/* Arabic version */}
      <link rel="alternate" hrefLang="ar" href={arUrl} />
      {/* Default/fallback version */}
      <link rel="alternate" hrefLang="x-default" href={enUrl} />
    </Helmet>
  );
};

export default Hreflang;
